import { FilePenLine } from "lucide-react";
import React from "react";
import { useForm } from "react-hook-form";
import TextAreaField from "../../components/form/TextAreaField";
import InputField from "../../components/form/InputField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { donorProposalEmail } from "../../features/projectsSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import { closeModal } from "../../features/modalSLice";
import { useNavigate } from "react-router-dom";
import FilesUpload from "./../../components/form/FilesUpload";
import { isArray } from "lodash";

const SendReformMail = ({ project_id, donor_id, donor, name, file }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addNotification = useNotification();
  const loading = useSelector(
    (state) => state.projects.load.donorProposalEmail
  );
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const fileWatch = watch("file_type");

  const onSubmit = async (data) => {
    try {
      if (fileWatch && file) {
        if (!isArray(data.documents)) {
          data.documents = [file];
        } else data.documents.push(file);
      }

      const res = await dispatch(
        donorProposalEmail({ project_id, donor_id, data })
      );
      if (donorProposalEmail.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification(res.payload.message, "success");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <div className="min-w-[85vw] sm:min-w-[35rem] lg:min-w-[50rem] max-w-4xl w-full text-text-1/80">
      <div className="flex  justify-right items-center gap-2 py-3 border-b border-bkg2 mb-4 text-text-1/80">
        <FilePenLine />
        <h4> {` Send Mail - ${donor}`} </h4>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="mb-4 flex gap-2">{name}</p>
        <InputField
          register={register}
          label="Subject"
          name="subject"
          errors={errors.subject}
        />
        <TextAreaField
          register={register}
          label="Body"
          name="body"
          errors={errors.comment}
        />
        <div className="flex gap-4 py-2 my-3">
          <label>System Files</label>
          <input
            type="checkbox"
            {...register("file_type")}
            className="inline-block transform"
          />
        </div>

        <div className="">
          <FilesUpload
            watch={watch}
            accept="application/pdf"
            register={register}
            name="documents"
            label="Documents"
            setValue={setValue}
            errors={errors.documents}
          />
        </div>

        <ResourseButtons loading={loading} submitText="Send Mail" />
      </form>
    </div>
  );
};

export default SendReformMail;
